
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import React from "react";
import { Col, Row } from "reactstrap";
import BaseLayout from "@components/BaseLayout";
/**
 * Cottbus-spezifische "Über"-Page
 */
const UeberPage: React.FC = () => {
    const { t } = useTranslation("common");
    return <BaseLayout pageTitle={t("page.index.title")} isFrontPage={true}>
    <div className="frontpage-content">
      <section className="on-white section-padding-tall text-center ">
        <Row className="no-flex text-center ">
          <h1>
            Über das Projekt IdeenLAB
          </h1>
          <p className="margin-top">Das Projekt IdeenLAB ist ein gemeinsames Vorhaben der Stadt Cottbus/Chóśebuz und der Brandenburgischen Technischen Universität Cottbus-Senftenberg innerhalb des Förderprogramms Modellprojekte &#39;Smart Cities&#39; (2019-2024).</p>
          <h2 className="light margin-top">
            Hintergrund
          </h2>
          <p className="margin-top">
            Die Stadt Cottbus/Chóśebuz setzt als Smart City auf eine <a href="https://cottbus-digital.de/de/digitales-cottbus/ueberblick-zum-projekt-smart-city.html" target="_blank" rel="noreferrer">digitale Zukunft</a>.
            Es geht nicht nur darum, die Stadt zu vernetzen und zu einem innovativen und zukunftsfähigen Wirtschaftsstandort
            zu machen. Sondern auch darum, dass Bürger:innen die Vorzüge der Digitalisierung erleben und aktiv an deren
            Entwicklung teilhaben können.
          </p>
          <p>In <a href="https://cottbus-digital.de/de/handlungsfelder.html" target="_blank" rel="noreferrer">sieben Handlungsfeldern</a> werden Entwicklungsmöglichkeiten ermittelt, Netzwerke aufgebaut sowie konkrete Projekte und Maßnahmen für die
            Daseinsvorsorge umgesetzt. Das Handlungsfeld Bildung umfasst im Rahmen von Smart City zwei Projekte:
            ein <a href="https://cottbus-digital.de/de/handlungsfelder/bildung/artikel-virtuelles-bildungs-und-austauschportal.html" target="_blank" rel="noreferrer">virtuelles Bildungs- und Austauschportal</a> für pädagogisches Fachpersonal und die Plattform IdeenLAB.
          </p>
        </Row>
      </section>
      <section>
        <Row>
          <Col>
            <h2 className="text-center text-lg-left">Der Nutzen für die Bürger:innen:</h2>
            <p>
              Sie können sich beteiligen! Das IdeenLAB ist die Plattform, die Funktionalitäten, Materialien, Veranstaltungen und Unterstützung für all jene bietet, die sich für Bildung in Cottbus einsetzen möchten. Es war noch nie so einfach,  Ideen einzureichen und  daraus echte Projekte zu entwickeln. Im IdeenLAB können Bürger:innen selbst wirksam werden und ihre Projektergebnisse für alle nutzbar machen.
            </p>
            <p>
              Hinzu kommt der Vernetzungseffekt: Ideengeber:innen treffen Menschen mit Projekterfahrung, Bürger:innen mit Problemen finden solche mit Lösungen. Es entsteht eine Gemeinschaft des bürgerschaftlichen Engagements, die die Plattform nutzt, um sich und ihre Projekte zu organisieren.</p>
          </Col>
          <Col>
            <h2 className="text-center text-lg-left">Die Idee des IdeenLAB:</h2>
            <p>Damit Cottbus digital bzw. smart funktioniert, braucht die Stadt Bürger:innen, die sich in ihr gern weiterhin selbstbestimmt und zuversichtlich bewegen und damit auch digitale Werkzeuge nutzen können. Es geht darum, die Menschen aktiv an der Gestaltung von Maßnahmen und Projekten teilhaben zu lassen – die dann auf breitere Akzeptanz stoßen sowie als sinnvoll erachtet und genutzt werden. Für diese Teilhabe steht das IdeenLAB.
            </p>
            <p>
              Cottbuser:innen formulieren hier nicht nur ihre Ideen, sondern leiten daraus auch echte Projekte ab. Es entstehen Projekte von Bürger:innen für Bürger:innen, die das Handlungsfeld Bildung vorantreiben. So fördert das IdeenLAB auf innovative Weise eine Kultur der Beteiligung in der Bürgerschaft.
            </p>
          </Col>
        </Row>
      </section>
      <section className="on-white">
        <Row className="no-flex row-narrow">
          <h2 className="text-center ">Die Ziele im Überblick:</h2>
          <div className="paragraph margin-top">
            <ol>
              <li>Bürger:innen in Entwicklungsprozesse einbinden und Mitmach-Mentalität stärken</li>
              <li>Ideen und Projekte veröffentlichen und entwickeln</li>
              <li>Bürger:innen aktivieren, sich zu engagieren</li>
              <li>Netzwerk aus Mitmacher:innen und Unterstützer:innen aufbauen</li>
              <li>Bürger:innen anregen, das Handlungsfeld Bildung dem digitalen Zeitalter entsprechend mitzugestalten</li>
            </ol>
          </div>
          <Link href="/"><a className="btn primary-btn margin-top">Zurück zur Startseite</a></Link>
        </Row>
      </section>

      <section>
        <div className="text-center">
          <h2 className="text-center">Die Entwicklung des IdeenLAB:</h2>
        </div>
        <Row>
          <Col>
            <p>
              Zu Beginn des IdeenLAB fragten wir alle Cottbuser:innen, welche Probleme ihnen mit der Digitalisierung, insbesondere im Bereich der Bildung, begegnen. Wir wollten wissen, was ihnen fehlt, um beim voranschreitenden Prozess der Digitalisierung mitzuwirken und welche Voraussetzungen erfüllt sein müssten, damit sie sich dort einbezogener fühlen.
            </p>
            <p>
              So kamen in der Zeit zwischen März und Mai 2023 rund 300 Anliegen der Bürger:innen von Cottbus zusammen, aus denen  8 Aktionsfelder entstanden.
            </p>
            <p>
              2023 war das IdeenLAB in folgende drei Phasen unterteilt: 1. Probleme, 2. Ideen, 3. Projekte. Nachdem die Phase 1 beendet war, öffnete das IdeenLAB mit all seinen Plattform-Funktionalitäten. Es konnten Ideen eingereicht und Projekte entwickelt werden. Das geht heute im Übrigen immer noch, auch wenn die Phasen nun anders heißen: 1. Ideen, 2. Projekte, 3. Wirkung.
            </p>
          </Col>
          <Col>
            <p>
              Ab jetzt kannst Du Dich noch einfacher engagieren. Du kannst:
            </p>
            <ul className="paragraph">
              <li>… ein Anliegen in einem Aktionsfeld bearbeiten und eine passende Lösungsidee dazu entwickeln.</li>
              <li>…  eine neue Idee einbringen, die ein neues bildungsrelevantes Anliegen löst (das Anliegen kann auch einfach zusammen mit der Idee formuliert werden).</li>
              <li>… Dich anderen anschließen und bei einem – oder sogar mehreren – Projekten mitmachen, die bereits veröffentlicht wurden.</li>
            </ul>
            <p>
              Falls Du noch Fragen hast, freuen wir uns über <Link href="/kontakt"><a>Deine Nachricht</a></Link>.
            </p>
          </Col>
        </Row>
      </section>

    </div>
  </BaseLayout>;
};
export default UeberPage;

    async function __Next_Translate__getStaticProps__191dbbef762__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ueber',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__191dbbef762__ as getStaticProps }
  